import React from 'react';

// Navigation
import { Link } from 'react-router-dom';

// Icons
import 'font-awesome/css/font-awesome.min.css';

// Helpers
import Helpers from '../../helpers';

// Components
import FunctionalButton from '../Buttons/FunctionalButton';

interface Features {
    id: number;
    title: string;
    mainImage: any;
    category: string;
    priceData: any;
}

const ProductItem: React.FC<Features> = (props) => {
    return (
        <div className="flex flex-col justify-between bg-white p-3 rounded-lg shadow-lg">
            <div>
                {
                    props.mainImage !== null ?
                        <img
                            src={props.mainImage}
                            alt={props.title}
                            className="w-full h-64 object-contain mb-4 rounded-lg"
                        />
                        :
                        <img
                            src={require("../../assets/images/no-image.png")}
                            alt={props.title}
                            className="w-full h-64 object-contain mb-4 rounded-lg"
                        />
                }

                <a href="#" className="text-lg font-semibold mb-2">
                    {props.title}
                </a>
                <p className="my-2">{props.category}</p>
                <div className="flex items-center mb-4">
                    {
                        props.priceData !== null ?
                            props.priceData.discountPrice !== 0 ?
                                <>
                                    <span className="text-lg font-bold text-primary">
                                        {props.priceData.discountPriceWithSymbol}
                                    </span>
                                    <span className="text-sm line-through ml-2">{props.priceData.withSymbol}</span>
                                </>
                                :
                                <>
                                    <span className="text-lg font-bold text-primary">
                                        {props.priceData.withSymbol}
                                    </span>
                                </>
                            :
                            <span className="text-lg font-bold text-primary">
                                {Helpers.translation('ask_for_price')}
                            </span>
                    }
                </div>
            </div>

            <Link
                className="flex items-center"
                to={"/products/" + props.id}
            >
                <FunctionalButton
                    text={Helpers.translation("view")}
                    rounded
                />
            </Link>
        </div>
    );
}

export default ProductItem;